import { createContext, useCallback, useMemo, useState } from 'react';
import { LOCAL_STORAGE_KEYS } from '../../constants/LocalStorageKeys';
import { jsx as _jsx } from "react/jsx-runtime";
export const MediaVolumeContext = /*#__PURE__*/createContext({
  setVolume: () => undefined,
  volume: 1
});
export const MediaVolumeProvider = ({
  children,
  mediaRef
}) => {
  const [volume, setVolume] = useState(1);
  const handleSetVolume = useCallback(nextValue => {
    setVolume(nextValue);
    try {
      localStorage.setItem(LOCAL_STORAGE_KEYS.MEDIA_VOLUME, nextValue.toString());
    } catch (error) {
      // Do nothing
    }
    if (mediaRef.current) {
      mediaRef.current.volume = nextValue;
    }
  }, [mediaRef]);
  const value = useMemo(() => ({
    setVolume: handleSetVolume,
    volume
  }), [handleSetVolume, volume]);
  return /*#__PURE__*/_jsx(MediaVolumeContext.Provider, {
    value: value,
    children: children
  });
};